<template>
  <ModalDefault modal_id="showTagsModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_736')"
                :footer="tags.tag.name"
                :method="updateTag"
                icon="bx bx-purchase-tag mr-1">
    <div class="px-2 py-2 pb-3" slot="body" style="margin-bottom: 30px;">
      <div>
        <div class="d-flex">
          <div class="cursor-default w-100" style="align-items: center; align-self: center;">
            <div class="d-block pt-2 px-2">
              <div class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_516') }}</label>
                <div class="input-group mb-4">
                  <input 
                    type="text"
                    v-model="tags.tag.name"
                    class="input-modern"
                    placeholder="Digite o nome da tag"
                  />
                </div>
              </div>
              <div class="col-12 px-0">
                <label class="mb-0">Cor da tag:</label>
                <ColorPicker 
                  ref="colorPicker" 
                  @change="color => (tags.tag.color = color)"
                  v-model="tags.tag.color"
                  :default-value="tags.tag.color" 
                />
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex justify-end">
      <button @click.prevent="updateTag" data-dismiss="modal"
              class="btn-custom">
        {{ getTranslations('expression_120') }}
      </button>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import ColorPicker from "../kanban/ColorPicker.vue";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";

export default {
  name: "ModalEditTag",
  components: {
    ModalDefault,
    ColorPicker
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['channels', 'tags']),
    ...mapGetters(['getTranslation'])
  },
  methods: {
    updateTag() {
      if (this.tags.tag.name.length < 3) return;
      this.$store.dispatch('updateTag', this.tags.tag);
      $('#showTagsModal').modal('hide');
    },
    resetModalState() {
      // Reseta a cor para o valor padrão sempre que o modal é aberto
      this.$refs.colorPicker.resetColor();
    }
  },
  mounted() {
    // Escuta o evento de abertura do modal
    $('#showTagsModal').on('show.bs.modal', this.resetModalState);
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

* {
  font-family: 'Poppins', sans-serif;
}


.input-modern {
  width: 100%; 
  height: 40px; 
  padding: 10px 15px; 
  font-size: 14px; 
  color: #333; 
  background-color: #f9f9f9; 
  border: 2px solid #ddd;
  border-radius: 12px; 
  outline: none; 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
  transition: border-color 0.3s, box-shadow 0.3s; 
}

.input-modern:focus {
  border-color: #222; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15); 
}

.input-modern:hover {
  border-color: #aaa; 
}


.btn-custom {
  background-color: #222; 
  color: #fff; 
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 12px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
  transition: all 0.3s ease; 
  border: none; 
  cursor: pointer;
}

.btn-custom:hover {
  background-color: #333; 
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15); 
  transform: scale(1.05); 
}

.btn-custom:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2); 
}
</style>



